var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fields.pageintro)?_c('ScText',{attrs:{"field":_vm.fields.pageintro,"tag":"PageIntro"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }